import moment from 'moment-timezone';

const isMidnightFrom = (momentValue) => moment(momentValue).format('HH:mm') === '00:00';

export default isMidnightFrom;
